import { render, staticRenderFns } from "./QuotationsTable.vue?vue&type=template&id=0ec4f874&scoped=true&"
import script from "./QuotationsTable.vue?vue&type=script&lang=js&"
export * from "./QuotationsTable.vue?vue&type=script&lang=js&"
import style0 from "./QuotationsTable.vue?vue&type=style&index=0&id=0ec4f874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec4f874",
  null
  
)

export default component.exports